module.exports = __webpack_public_path__ + "img/studywayIcon7.8bc4e1e5.png";